(function () {
  function init() {
    document.querySelectorAll('[data-c21-preview]').forEach(function (preview) {
      if (preview.dataset.ready) return;
      preview.dataset.ready = 'true';
      var section = preview.closest('[data-section-type="product"]');
      function renderedForm() {
        return section.querySelector('#ProductFormWrapper') || section.querySelector('.acerill-product-form');
      }
      var labels = {name:'Full Name',title:'Title',brokerage:'Brokerage Name',direct:'Direct/Mobile Line',office:'Phone Number',email:'E-mail',website:'Website',address1:'Address Line 1',address2:'Address Line 2'};
      var defaults = {name:'Your Name',title:'Sales Representative',brokerage:'',direct:'000.000.0000',office:'000.000.0000',email:'email@century21.ca',website:'www.century21.ca',address:'555 Main St, Toronto ON L5M 8B4'};
      var generate = preview.querySelector('[data-c21-generate]');
      var cards = preview.querySelector('[data-c21-cards]');
      var status = preview.querySelector('[data-c21-status]');
      var addButton = section.querySelector('[name="add"]');
      var generated = false;
      var everGenerated = false;
      function sync() {
        if (addButton) addButton.disabled = false;
        generate.disabled = generated;
        generate.hidden = generated;
        preview.dataset.stale = String(!generated && everGenerated);
        status.textContent = generated ? preview.dataset.statusReady : preview.dataset.statusPending;
      }
      function read(key) {
        var input = section.querySelector('[name="properties[' + labels[key] + ']"]');
        return input ? input.value.trim() : '';
      }
      function draw() {
        var values = {};
        Object.keys(labels).forEach(function (key) { values[key] = read(key); });
        values.address = [values.address1, values.address2].filter(Boolean).join(', ');
        var small = false;
        preview.querySelectorAll('[data-c21-text]').forEach(function (node) {
          var key = node.dataset.c21Text;
          node.textContent = values[key] || defaults[key] || '';
          var size = Number(node.dataset.size);
          node.setAttribute('font-size', size);
          if (typeof node.getComputedTextLength === 'function') {
            var width = node.getComputedTextLength();
            if (width > Number(node.dataset.width)) {
              size = size * Number(node.dataset.width) / width;
              node.setAttribute('font-size', size);
              if (size < 6) small = true;
            }
          }
        });
        preview.querySelector('[data-c21-fit-note]').hidden = !small;
      }
      function invalidate() { generated = false; sync(); }
      function fieldEdited(event) {
        if (event.target.closest('#ProductFormWrapper, .acerill-product-form')) invalidate();
      }
      section.addEventListener('input', fieldEdited);
      section.addEventListener('change', fieldEdited);
      generate.addEventListener('click', function () {
        var form = renderedForm();
        var fields = form ? Array.from(form.querySelectorAll('input, textarea, select')) : [];
        if (!fields.length) return;
        var invalid = fields.find(function (field) { return !field.checkValidity(); });
        if (invalid) { invalid.reportValidity(); return; }
        generated = true;
        everGenerated = true;
        cards.hidden = false;
        draw();
        sync();
      });
      function placeAfterFields() {
        var form = renderedForm();
        if (form && form.nextElementSibling !== preview) form.insertAdjacentElement('afterend', preview);
      }
      placeAfterFields();
      new MutationObserver(placeAfterFields).observe(section, {childList:true,subtree:true});
      if (addButton) new MutationObserver(function () {
        if (addButton.disabled) addButton.disabled = false;
      }).observe(addButton, {attributes:true,attributeFilter:['disabled']});
      cards.hidden = false;
      sync();
      if (document.fonts) document.fonts.ready.then(function () { if (generated) draw(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
